import { ApplicationHeaderWrapper, ApplicationSidebarWrapper, Banner, BannerProps, Spinner } from '@msdk/ui'
import { styled } from '@msdk/ui'

const SplashScreen = styled('div')`
  display: flex;
  flex-direction: column;
  position: absolute;
  inset: 0;
  background-color: #fafafa;
  z-index: 99999;
  pointer-events: none;
  height: 100%;
`

const CenteredContainer = styled('div')`
  display: block;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`

const Container = styled('div')`
  flex: 1;
  width: 100%;
  position: relative;
`

const LoaderWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export function FullScreenLoader({ banner }: { banner?: BannerProps }) {
  return (
    <SplashScreen>
      {banner && <Banner squared title={banner.title} message={banner.message} severity="info" variant="filled" />}
      <Container>
        <ApplicationSidebarWrapper />
        <ApplicationHeaderWrapper />
        <CenteredContainer>
          <LoaderWrapper>
            <Spinner size={32} />
          </LoaderWrapper>
        </CenteredContainer>
      </Container>
    </SplashScreen>
  )
}
